<template>
	<div class="versus">
		<Background :rotating="true" />

		<div class="player player-1" :class="{start: start}">
			<Prop color="orange" />
		</div>

			<div class="player player-2" :class="{start: start}">
				<Prop color="pink" />
			</div>

			<div class="buttons">
				<Button value="VS" />
			</div>
	</div>
</template>

<script>
import Background from '@/components/Background.vue';
import Button from '@/components/Button.vue';
import Prop from '@/components/Prop.vue';

export default {
	components: {Background, Button, Prop},
	props: [],
	data() {
		return {
			start: false
		}
	},
	mounted() {
		setTimeout(() => {
			this.start = true;
		},300);
	}
}
</script>
<style lang="scss">
.player {
	svg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
	}
}
</style>
<style scoped lang="scss">
	.versus {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999999;
		overflow: hidden;
		pointer-events: none;
		background: linear-gradient(120deg, #c677ff 50%, #F251A5 50.3%);
		.buttons {
			position: fixed;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
		.background {
			position: relative;
		}

		.player {	
			width: 40vw;
			position: fixed;
			left: auto;
			right: auto;
			bottom: 0;
			z-index: 99999;
			transition: all 0.3s;
			
			&.player-1 {
				top: 100%;
				left: -75%;
				&.start {
					top: 50%;
					left: 45%;
					transform: translateX(-100%) translateY(-50%);
					animation: zoom-in-player-1 5s ease-in-out;
				}

			}
			&.player-2 {
				top: -100%;
				right: -75%;
				&.start {
					top: 50%;
					right: 45%; 
					transform: translateX(100%) translateY(-50%);
					animation: zoom-in-player-2 5s ease-in-out;
				}

			}

			@keyframes zoom-in-player-1 {
				0% {
					transform: translateX(-100%) translateY(-50%) scale(1);
				}
				100% {
					transform: translateX(-100%) translateY(-50%) scale(1.5);
				}
			}

			@keyframes zoom-in-player-2 {
				0% {
					transform: translateX(100%) translateY(-50%) scale(1);
				}
				100% {
					transform: translateX(100%) translateY(-50%) scale(1.5);
				}
			}


			/* svg {
				transform: translate(-50%,-50%);
				width: 100%;
				height: 100%;
				max-width: 25rem;
				left: 50%;
				top: 50%;
				max-height: 25rem;
				pointer-events: all;
				position: absolute;
			} */
		}

	}
</style>